export default (x, y, width, height, color) =>
  `<?xml version="1.0" encoding="iso-8859-1"?> <svg x="${x}px" y="${y}px" width="${width}px" height="${height}px" fill="${color}" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	   viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
  <title>router_1</title>
  <g>
	  <path d="M10,16l-2-2l-4.4,4.5l-2.9-2.8l0.1,7.9l7.9-0.1l-2.9-2.8L10,16z M23.5,15.4l-2.8,2.9L2.4,0.7l-2,2l18.2,17.8l-2.8,2.9
		  l7.9-0.1L23.5,15.4z M16,9.9l7.4-7.5l-2-2L14,8L16,9.9z"/>
  </g>
  </svg>`;
